export default __webpack_public_path__ + "static/media/about-team-23.cfed6bbe.jpg";